// extracted by mini-css-extract-plugin
export default {"page-centered":"CFASpinner_page-centered__5BSCy"};